export default "__VITE_ASSET__24f13113__"